import { useEffect } from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
// material
import { styled } from "@material-ui/core/styles";
import { Box, Stack, Drawer } from "@material-ui/core";
// hooks
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import useCollapseDrawer from "../../../hooks/useCollapseDrawer";
import Scrollbar from "../../../components/Scrollbar";
import NavSection from "../../../components/NavSection";
import { MHidden } from "../../../components/@material-extend";
//
import { getSidebarConfig } from "./SidebarConfig";
import { isMobile } from "react-device-detect";
import { PATH_LEVEL } from "utils/dataCenter";
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.complex,
    }),
  },
}));

type DashboardSidebarProps = {
  isOpenSidebar: boolean;
  onCloseSidebar: VoidFunction;
};

export default function DashboardSidebar({
  isOpenSidebar,
  onCloseSidebar,
}: DashboardSidebarProps) {
  const { pathname } = useLocation();
  const { shop } = useSelector((state: RootState) => state.auth);
  console.log("auth shop : ", shop);
  const {
    isCollapse,
    collapseClick,
    collapseHover,
    onHoverEnter,
    onHoverLeave,
  } = useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  //   const handleToOrderDownload = () => {
  //     axios({
  //       url: `${s3Config.EXE_URL}toorderexe.zip`,
  //       method: "GET",
  //       responseType: "blob", // important
  //     }).then((response) => {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "toOrderexe.zip");
  //       document.body.appendChild(link);
  //       link.click();
  //     });
  //   };
  const companyName = shop.NAME;
  const companyAUTH = shop.SHOP_AUTH;
  const usePlugInNB = shop.PLUG_IN_NB;
  const usePlugInMA = shop.PLUG_IN_MA;

  const sidebarConfig = getSidebarConfig(shop);

  const authName =
    companyName.length > 10 ? companyName.replace(/\s/, "\n") : companyName;
  const authNameSize = companyName.length > 10 || isMobile ? "20px" : "25px";

  const renderContent = (
    <Scrollbar
      sx={{
        height: "100%",
        "& .simplebar-content": {
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: "#1E2431",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          borderBottom: "1px solid #302f46",
          px: 2.5,
          pt: 3,
          pb: 2,
          ...(isCollapse && {
            alignItems: "center",
          }),
        }}
      >
        <RouterLink to="/" style={{ textDecoration: "none" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              color: "white",
              fontSize: authNameSize,
              fontWeight: "600",
              height: 47,
            }}
          >
            {authName}
          </Stack>
        </RouterLink>
      </Stack>

      <NavSection navConfig={sidebarConfig} isShow={!isCollapse} />

      <Box sx={{ flexGrow: 1 }} />
      <div
        style={{
          // background: "yellow",
          background: "#1E2431",
          display: "flex",
          justifyContent: "center",
        }}
      ></div>
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? COLLAPSE_WIDTH : DRAWER_WIDTH,
        },
        ...(collapseClick && {
          position: "absolute",
        }),
      }}
    >
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              ...(isCollapse && {
                width: COLLAPSE_WIDTH,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              ...(isCollapse && {
                width: COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                borderRight: 0,
                bgcolor: "yellow",
                backdropFilter: "blur(6px)",
                WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
                boxShadow: (theme) => theme.customShadows.z20,
                // bgcolor: (theme) => alpha(theme.palette.background.default, 0.88)
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
